/**
 * Create Novel Page
 * Form for creating a new novel
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { NovelForm, type NovelFormData } from "../components/NovelForm";
import { api, ApiError } from "../lib/api";

export default function CreateNovel() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(data: NovelFormData) {
    setError(null);
    setIsLoading(true);

    try {
      const response = await api.novels.create({
        title: data.title,
        description: data.description || undefined,
        status: data.status,
      });

      navigate(`/novels/${response.novel.id}/chapters`);
    } catch (err) {
      if (err instanceof ApiError) {
        // Handle validation errors
        if (err.errors && err.errors.length > 0) {
          setError(err.errors.map((e) => e.message).join(", "));
        } else {
          setError(err.message);
        }
      } else {
        setError("Failed to create novel");
      }
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-slate-900">Create Novel</h1>

      {error && (
        <div className="p-3 bg-red-50 border border-red-200 rounded-md text-red-700 text-sm">
          {error}
        </div>
      )}

      <div className="max-w-2xl bg-white rounded-lg shadow-sm border border-slate-200 p-6">
        <NovelForm onSubmit={handleSubmit} isLoading={isLoading} />
      </div>
    </div>
  );
}
